<template>
	<div class="">
		<div class="chart-in1">			
			<h2 class="h2-1">{{mychartTitle}}</h2>		
			<div :id="mychartID" class="chart-black1"></div>
		</div>
	</div>
</template>
<script>
import echarts from "echarts/lib/echarts"
import 'echarts/map/js/china.js';

export default {
  name: 'app',
  data(){
    return {
		mychartData: this.chartData || {name:[],value:[]},
		mychartTitle: this.chartTitle || "",
		mychartID: this.chartID || ""
    }
  },
  mounted(){
    this.$nextTick(function(){
    	this.drawChart();
	  })
	const timer = setInterval(() => {
		this.drawChart();			
	}, 5000);
	this.$once('hook:beforeDestroy', () => {
		clearInterval(timer);
	})
  },
  props:['chartData','chartTitle','chartID'],
  methods: {
	drawChart(){
		let chart = this.$echarts.init(document.getElementById(this.mychartID));		
		chart.setOption({
			baseOption: {
				tooltip : {
					trigger: 'axis',
					formatter: "{b}：{c}",
					axisPointer : {            // 坐标轴指示器，坐标轴触发有效
						type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
					}
				},
				color: ['#fff','#ff4e3c','#ff7e1d','#ff7e1d','#ff7e1d','#39deff','#39deff','#39deff','#39deff','#39deff'],
				
				grid: {
					left: '12%',
					right: '12%',
					bottom: '6%',
					top:'4%',
					containLabel: true
				},
				xAxis : [
					{
						type : 'category',
						// data : ['机柜9', '机柜6', '机柜7', '机柜8', '机柜5', '机柜10', '机柜3', '机柜11', '机柜1', '机柜13'],
						data : this.mychartData.name || [],
						axisTick: {
							alignWithLabel: true
						},
						axisLine: {
							lineStyle: {
								color: '#eee'
							}
						},
					}
				],
				yAxis : [
					{
						type : 'value',
						axisLine: {
							lineStyle: {
								color: '#eee'
							}
						},
					}
				],
				series : [
					{
						name: this.mychartTitle,
						type:'bar',
						barWidth: '35',
						// data: [1000, 520, 400, 334, 290, 230, 220, 190, 130, 120],
						data: this.mychartData.value || [],
						itemStyle: {   
							normal:{  
									//var colorList = ['#31b0d5','#c9302c','#5cb85c','#aaa'];
								color: function (params){
									var colorList = ['#ff4e3c','#ff4e3c','#ff7e1d','#ff7e1d','#ff7e1d','#39deff','#39deff','#39deff','#39deff','#39deff'];
									return colorList[params.dataIndex];
								}
							}
						},
					}
				]

			}		
	
		});
	},
	
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/comss/chartTwo.vue